import {Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {Constants} from '../../constants/constants';
import {ExportarExcel} from '../../utileria/exportar-tabla-excel';
import {FormArray, FormBuilder, FormGroup} from '@angular/forms';
import {PreferencesUserInterface} from '../../interfaces/preferences-user.interface';
import {AuthenticationService} from '../../services/authentication.service';
import {UspreferService} from '../../services/usprefer.service';
import {UtileriasService} from '../../services/utilerias.service';

@Component({
  selector: 'app-exportar-excel',
  templateUrl: './exportar-excel.component.html',
  styleUrls: ['./exportar-excel.component.scss']
})
export class ExportarExcelComponent implements OnInit {
  @ViewChild('modalExcel') modal: ElementRef;
  @Input() tableNative: any;
  @Input() lengthData: any;
  @Input() displayedColumns: any;
  @Input() formatColumn: any;
  @Input() dataSource: any;
  @Input() dataNames: any;
  @Input() tableBD: any;
  keys: any;
  form: FormGroup;
  displayedColumnsAux = [];
  identificador = '_export_excel';
  preferenceStorage;

  constructor(private modalService: NgbModal,
              private constants: Constants,
              private fb: FormBuilder,
              private excel: ExportarExcel,
              private authentication: AuthenticationService,
              private _usprefer: UspreferService,
              private utileriasService: UtileriasService) {
  }

  ngOnInit(): void {

  }


  modalExportarExcel() {

    if (this.tableBD !== undefined) {
      const storage = sessionStorage.getItem((this.tableBD + this.identificador));
      if (storage !== null && storage !== undefined) {
        this.preferenceStorage = JSON.parse(this.utileriasService.decrypt(storage));
      }
    }

    this.displayedColumnsAux = [...this.displayedColumns];

    this.form = this.fb.group({
      columnaSeleccionada: this.fb.array([])
    });

    this.displayedColumnsAux.forEach((value, index) => {
      if (this.formatColumn[index] !== this.constants.CONTROL) {

        if (this.preferenceStorage !== undefined && this.preferenceStorage !== null) {
          if (Object.values(this.preferenceStorage).includes(value) == true) {
            (this.form.get('columnaSeleccionada') as FormArray).push(this.fb.control(true));
          } else {
            (this.form.get('columnaSeleccionada') as FormArray).push(this.fb.control(false));
          }
        } else {
          (this.form.get('columnaSeleccionada') as FormArray).push(this.fb.control(true));
        }
      } else {
        (this.form.get('columnaSeleccionada') as FormArray).push(this.fb.control(false));
      }
    });

    if (this.lengthData !== undefined && this.lengthData > 0) {
      this.modalService.open(this.modal, {
        backdrop: 'static',
        scrollable: true,
        keyboard: false,
        size: 'sm'
      });

    }
  }


  exportarColumnas() {
    const seleccionados = this.getSeleccionados();
    this.excel.exportarExcel(this.tableNative, seleccionados, this.dataSource);
  }


  getSeleccionados() {
    return this.form.value.columnaSeleccionada
      .map((valor: boolean, i: number) => valor ? this.displayedColumnsAux[i] : null)
      .filter((fruta: string | null | undefined) => fruta !== null && fruta !== undefined);
  }

  updatePreferenceDataBase(): void {
    const seleccionados = {...this.getSeleccionados()};

    const preferenceUser: PreferencesUserInterface = {
      idusuari: this.authentication.idUsuario,
      tabla: this.tableBD + this.identificador,
      preferencias: JSON.stringify(seleccionados)
    }
    if (this.tableBD !== undefined) {
      this._usprefer.postUsprefer(preferenceUser).subscribe();
      sessionStorage.setItem(this.tableBD + this.identificador, this.utileriasService.encrypt(preferenceUser.preferencias));
    }

  }

  selectAll() {
    (this.form.get('columnaSeleccionada') as FormArray).controls.forEach(control => control.setValue(true));
  }


}
